import {Json} from '../../../components/JsonObjectCard';
import {RequestExample} from '../../../components/RequestExampleCard';
import {RequestDefinitionData} from '../../../components/RequestDefinition';

const unrequestTransferOrderRequest: RequestExample = {
    title: {
        verb: 'POST',
        endpointUrl: '/api/transfer-orders/:id/unrequest',
    },
    curl:
        `curl --location \\
--request POST '<YOUR SERVER>/api/transfer-orders/:id/unrequest' \\
--header 'Authorization: Bearer <TOKEN>'
`,
};

const unrequestTransferOrderResponse: Json = {
    title: 'RESPONSE',
    json: {
        'id': 23,
        'number': '25',
        'status': 'Entered',
        'type': 'Ship',
        'fromLocationGroup': {
            'id': 1,
            'name': 'Main'
        },
        'toLocationGroup': {
            'id': 2,
            'name': 'NY'
        },
        'carrier': {
            'id': 4,
            'name': 'Fedex',
            'service': {
                'id': 8,
                'name': 'Ground'
            }
        },
        'shipFromAddress': {
            'name': 'Main Warehouse',
            'street': '100 Main St',
            'city': 'Salt Lake City',
            'state': 'UT',
            'postalCode': '84101',
            'country': 'UNITED STATES'
        },
        'shipToAddress': {
            'name': 'East Warehouse',
            'street': '200 East Blvd',
            'city': 'Denver',
            'state': 'CO',
            'postalCode': '80201',
            'country': 'UNITED STATES'
        },
        'note': 'Urgent transfer for Q2 rebalancing',
        'ownerIsFrom': true,
        'revisionNumber': 3,
        'lastModified': {
            'username': 'admin',
            'dateLastModified': '2026-06-25T16:34:12.000+00:00'
        },
        'dateCreated': '2026-05-26T15:45:27.000+00:00',
        'dateScheduled': '2025-12-29T01:44:45.000+00:00',
        'toItems': [
            {
                'id': 91,
                'part': {
                    'id': 28,
                    'name': 'B201',
                    'description': 'Premium Brake Cables'
                },
                'type': {
                    'id': 10,
                    'name': 'Send'
                },
                'status': 'Entered',
                'uom': {
                    'id': 1,
                    'name': 'Each',
                    'abbreviation': 'ea'
                },
                'lineNumber': 1,
                'note': 'Handle with care',
                'quantity': '10',
                'unitCost': '25.50',
                'dateScheduled': '2026-05-26T15:45:27.000+00:00'
            }
        ],
        'customFields': [
            {
                'id': 22,
                'name': 'Department',
                'value': 'Logistics',
                'type': 'Text'
            }
        ]
    },
};

const data: RequestDefinitionData = {
    id: 'unrequest-transfer-order',
    title: 'Unrequest a transfer order',
    description: 'Transitions a transfer order from Request status back to Entered, cancelling the request ' +
        'before the receiving party has issued it. ' +
        'The transfer order must be in Request status. ' +
        'Only the owner location group can unrequest a transfer order — a user with access to both ' +
        'location groups, or to only the non-owner location group, cannot. ' +
        'Returns 404 if the transfer order is not found.',
    endpoint: {
        verb: 'POST',
        path: '/transfer-orders/:id/unrequest',
        tooltip: 'Unrequest a transfer order',
    },
    attributes: [],
    requestObject: unrequestTransferOrderRequest,
    responseObject: unrequestTransferOrderResponse,
};

export default data;
